import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom'

export default function IPFS() {

    const { txId } = useParams();

    const { i18n } = useTranslation();

    return (
        <iframe title="IPFS" src={`https://ipfs.trato.io${txId ? `/#/explore/${txId}` : '?lng=' + i18n.language}`} seamless frameBorder="0" width="100%" height="1000px" />
    )
}